import { render, staticRenderFns } from "./vehicle-drilldown.vue?vue&type=template&id=047d8928&scoped=true"
import script from "./vehicle-drilldown.vue?vue&type=script&lang=js"
export * from "./vehicle-drilldown.vue?vue&type=script&lang=js"
import style0 from "./vehicle-drilldown.vue?vue&type=style&index=0&id=047d8928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d8928",
  null
  
)

export default component.exports